import { render } from "./AppealEdit.vue?vue&type=template&id=a6491434"
import script from "./AppealEdit.vue?vue&type=script&lang=js"
export * from "./AppealEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/direct_mail/AppealEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6491434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6491434', __exports__)) {
    api.reload('a6491434', __exports__)
  }
  
  module.hot.accept("./AppealEdit.vue?vue&type=template&id=a6491434", () => {
    api.rerender('a6491434', render)
  })

}


export default __exports__